// extracted by mini-css-extract-plugin
export var btn = "notFound-module--btn--cb1f7";
export var content = "notFound-module--content--0e33a";
export var image = "notFound-module--image--6812d";
export var link = "notFound-module--link--2d8ff";
export var notFound = "notFound-module--notFound--8de58";